document.addEventListener("DOMContentLoaded", () => {

  const nav = document.querySelector(".header__nav--rebuild");
  if (!nav) return;

  const items = nav.querySelectorAll("details.hdr-dd");

  let closeTimeout;

  items.forEach((item) => {

    item.addEventListener("mouseenter", () => {

      clearTimeout(closeTimeout);

      
      items.forEach((other) => {
        if (other !== item) other.removeAttribute("open");
      });

      item.setAttribute("open", "true");
    });

    item.addEventListener("mouseleave", () => {

      closeTimeout = setTimeout(() => {
        item.removeAttribute("open");
      }, 150); 
    });

  });

 
  nav.addEventListener("mouseleave", () => {
    items.forEach((item) => item.removeAttribute("open"));
  });

});